module.exports = __webpack_public_path__ + "static/img/tocImage3.bc2ab96a.jpg";